// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BotonEnviar-module__divEnviar__97oWq {\r\n     text-align: center;\r\n     padding-top: 25px;\r\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divEnviar": "BotonEnviar-module__divEnviar__97oWq"
};
export default ___CSS_LOADER_EXPORT___;
